import Observable from './observable';
export default function fromEmitter(emitter) {
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return new Observable(function factory(observer) {
        // tslint:disable-next-line:ter-prefer-arrow-callback
        return emitter.listen(function callback(value) {
            observer.next(value);
        });
        // tslint:disable-next-line:ter-prefer-arrow-callback
    });
}
//# sourceMappingURL=from-emitter.js.map